import { render, staticRenderFns } from "./ConfirmAndAccept.vue?vue&type=template&id=ef368f00&scoped=true&"
import script from "./ConfirmAndAccept.vue?vue&type=script&lang=js&"
export * from "./ConfirmAndAccept.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAndAccept.vue?vue&type=style&index=0&id=ef368f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef368f00",
  null
  
)

export default component.exports